// extracted by mini-css-extract-plugin
export default {"main":"styles_main__e6CRN","progress":"styles_progress__0JkUm","text":"styles_text__ouXxU","divider":"styles_divider__BNoSR"};